import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { colors, fonts, spacing } from '../../../constants';
import { getUserDisplayName } from '../../../utils/queryDisplayUtils';
import { formatDateTime } from '../../../utils/dateUtils';
import SectionCard from './SectionCard';
import FieldLabel from './FieldLabel';
import FieldValue from './FieldValue';

/**
 * EscalationInfoSection Component
 * Displays escalation details
 * 
 * @param {Object} query - Query object
 * @param {boolean} isEscalated - Whether query is escalated
 * @param {string} escalatedByName - Name of user who escalated
 * @param {string} escalatedToName - Name of user query is escalated to
 * @param {string} escalatedAt - Escalation date/time
 * @param {boolean} isEscalatedViewOnly - Whether user has view-only access
 */
const EscalationInfoSection = ({
  query,
  isEscalated,
  escalatedByName,
  escalatedToName,
  escalatedAt,
  isEscalatedViewOnly,
}) => {
  if (!isEscalated) return null;

  return (
    <SectionCard title="Escalation Details">
      <Grid container spacing={2} sx={{ width: '100%', margin: 0 }}>
        {/* <Grid size={{ xs: 12, sm: 6 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <FieldLabel label="Escalated By" />
            <FieldValue value={escalatedByName || getUserDisplayName(query?.escalatedBy) || 'N/A'} />
          </Box>
        </Grid> */}
        <Grid size={{ xs: 6, sm: 12 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <FieldLabel label="Escalated To" />
            <FieldValue value={escalatedToName || getUserDisplayName(query?.escalatedTo) || 'N/A'} />
          </Box>
        </Grid>
        <Grid size={{ xs: 6, sm: 12 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <FieldLabel label="Escalated At" />
            <FieldValue
              value={
                escalatedAt
                  ? formatDateTime(escalatedAt)
                  : query?.escalatedAt || query?.escalationDate || query?.updatedAt
                    ? formatDateTime(query.escalatedAt || query.escalationDate || query.updatedAt)
                    : 'N/A'
              }
            />
          </Box>
        </Grid>
        {isEscalatedViewOnly && (
          <Grid size={{ xs: 12 }}>
            <Box
              sx={{
                mt: spacing.xs,
                p: spacing.xs,
                borderRadius: '4px',
                backgroundColor: colors.warning + '15',
                border: `1px solid ${colors.warning}40`,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: colors.warning,
                  fontSize: fonts.fontSizeSm,
                  fontWeight: fonts.weightMedium,
                }}
              >
                This query has been escalated to you. You have view-only access.
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
    </SectionCard>
  );
};

export default EscalationInfoSection;
